
import React, { useRef , useEffect } from 'react';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';

export default function ConfirmaDialog( {state , answer}) {



    useEffect(() => {

        confirm2()

    } ,[state])

    const toast = useRef(null);

    const accept = () => {
        answer( 1 )
        toast.current.show({ severity: 'info', summary: 'Confirmed', detail: 'You have accepted', life: 3000 });
    }

    const reject = () => {
        answer( 2 )
        toast.current.show({ severity: 'warn', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    }
/*
    const confirm1 = () => {
        confirmDialog({
            message: 'Are you sure you want to proceed?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            accept,
            reject
        });
    };
*/
    const confirm2 = () => {
        confirmDialog({
            message: 'Desea entrar al login ?',
            header: 'Confirmacion del Login',
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            accept,
            reject
        });
    };

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <div className="card flex flex-wrap gap-2 justify-content-center">
                {/* <Button onClick={confirm1} icon="pi pi-check" label="Confirm" className="mr-2"></Button> */}
                {/* <Button onClick={confirm2} icon="pi pi-times" label="Delete"></Button> */}
            </div>
        </>
    )
}
        